import Linked, { LinkedProps } from 'shared-components/service/Linked'
import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'
import styles from './AdvertiseLink.module.css'
import ArrowRightBird from 'shared-svg/ArrowRightBird.svg'

interface AdvertiseLinkProps extends BasicStyledComponent, LinkedProps {
  variant: 'normal' | 'inMenu'
}

const AdvertiseLink: React.FC<AdvertiseLinkProps & React.PropsWithChildren> = ({
  className,
  children,
  variant,
  ...props
}) => (
  <Linked
    {...props}
    className={clsx(className, styles.container, {
      [styles.inMenu]: variant === 'inMenu',
      [styles.normal]: variant === 'normal',
    })}
  >
    <div className={styles.inner}>
      {children}
      <ArrowRightBird className={styles.icon} />
    </div>
  </Linked>
)

export default AdvertiseLink
